import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './components/Toast';
import { TemaProvider } from './components/Tema';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

// Aplica el tema guardado antes del primer render para evitar el parpadeo (FOUC).
// Default claro: solo se activa el oscuro si el usuario lo eligió explícitamente.
// El favicon NO se toca acá: lo resuelve el navegador según su propio
// prefers-color-scheme (ver index.html), independiente del tema de la app.
if (typeof document !== 'undefined') {
  try {
    if (localStorage.getItem('procom-tema') === 'oscuro') {
      document.documentElement.classList.add('dark');
    }
  } catch { /* almacenamiento no disponible */ }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TemaProvider>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </TemaProvider>
    </QueryClientProvider>
  </StrictMode>,
);
